import { Input } from 'antd';
import { ChangeEvent, useEffect, useState, FC } from 'react'; // Import FC for Functional Component type

// Define the props interface
interface TrimmedInputProps {
  value?: string; // value will be provided by Form.Item, make it optional
  onChange?: (value: string) => void; // onChange will be provided by Form.Item
  defaultLable?: string; // Your custom prop
  // You can also include any other standard Input props if you want to pass them through
  [key: string]: any; // To allow other antd Input props like placeholder, etc.
}

const TrimmedInput: FC<TrimmedInputProps> = ({
  value: formValue, // Renaming for clarity, comes from Form.Item
  onChange,
  defaultLable,
  ...rest // To spread any other props to the Ant Input
}) => {
  // Initialize internalValue:
  // 1. If formValue is provided (e.g., from form's initialValues or subsequent updates), use it.
  // 2. Else, if defaultLable is provided, use it.
  // 3. Otherwise, fallback to an empty string.
  const [internalValue, setInternalValue] = useState<string>(formValue || defaultLable || '');

  // Effect to synchronize internalValue when formValue (from antd form) changes
  useEffect(() => {
    // Only update if formValue is actually defined and different
    // This prevents an infinite loop if onChange also updates formValue immediately
    if (formValue !== undefined && formValue !== internalValue) {
      setInternalValue(formValue);
    }
  }, [formValue]); // Only re-run if formValue changes

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.target.value;
    setInternalValue(currentValue);
    if (onChange) {
      onChange(currentValue); // Propagate change to the Ant Design Form
    }
  };

  const handleBlur = () => {
    const trimmedValue = (internalValue || '').trimStart();
    // Only update if the value actually changed after trimming
    if (trimmedValue !== internalValue) {
        setInternalValue(trimmedValue);
        if (onChange) {
          onChange(trimmedValue); // Propagate trimmed value to the Ant Design Form
        }
    }
  };

  return (
    <Input
      {...rest} // Spread other props like placeholder, etc.
      value={internalValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default TrimmedInput;